import * as React from "react";

export default ({ children }) => (
  <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/layout/Row.js